import ReactLoading from "react-loading";
import { Backdrop, Box } from "@mui/material";

import styles from "./loader.styles";
import { useAppSelector } from "../../hooks/useAppSelector";

const Loader = () => {
  const { loading } = useAppSelector((state) => state.globalcontent);

  return (
    <Backdrop sx={styles.loaderContainer} open={loading}>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <ReactLoading type="bars" color="white" height={100} width={50} />
      </Box>
    </Backdrop>
  );
};

export default Loader;
